import * as React from 'react'
import { observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { Elements } from '@tfo/common'
import './NoReports.scss'

const { Heading4 } = Elements

const NoReports = (props: WrappedComponentProps) => (
	<div className="NoReports">
		<div className={'Select__Icon'}>
			<div className={'Select__IconReportsBack'} />
			<div className={'Select__IconReportsFront'} />
		</div>
		<Heading4>
			{props.intl.formatMessage({ id: 'client.reports.empty.heading' })}
		</Heading4>
	</div>
)
export default injectIntl(observer(NoReports))
